import { c as _c } from "react/compiler-runtime";
import type { ReactNode, ReactElement } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import HeaderDropDownTitle from './HeaderDropDownTitle';
import HeaderDropDownItem from './HeaderDropDownItem';
interface Props {
  name: string;
  title: ReactNode;
  items: ReactElement[];
}
const Root = styled(ContentWrapper)(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: spacing(4),
  paddingBottom: spacing(6),
  gap: spacing(8)
}));
const ItemsContainer = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  gap: spacing(4)
}));
const Item = styled('div')(({
  theme: {
    palette,
    spacing
  }
}) => ({
  position: 'relative',
  '&:not(:first-of-type)::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: spacing(-2),
    display: 'block',
    width: 1,
    backgroundColor: palette.layout.line.divider
  }
}));
export default function HeaderDropDown(t0) {
  const $ = _c(10);
  const {
    title,
    items,
    name
  } = t0;
  const t1 = `header-submenu-${name}`;
  let t2;
  if ($[0] !== title) {
    t2 = <div>{title}</div>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div><ItemsContainer>{t3}</ItemsContainer></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <Root id={t1}>{t2}{t4}</Root>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(item, n) {
  return <Item key={item.props?.title ?? n}>{item}</Item>;
}
HeaderDropDown.Title = HeaderDropDownTitle;
HeaderDropDown.Item = HeaderDropDownItem;